import React from 'react';
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";

import {UserTypes} from "root/DataFunctions/Constants";
import DropdownUsers from "root/ReactHookForm/ui/DropdownUsers";

const HookSubFormESW = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const validateCarer = (val) =>
    {
        if (val === null)
        {
            return "Please Select a carer.";
        }
    }

    return (
        <FieldsetContainer title='ESW' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}    >
                    <label className='col-form-label'>Select an ESW (Use the filter to narrow down the list)</label>
                    <DropdownUsers name={sectionName + '.esw_id'} user_type={UserTypes.ESW} isClearable={false} control={control} rules={{validate: validateCarer}}
                                                      placeHolder='Pick an EIW' readOnly={readOnly} isSearchable={true}/>
                    {formErrors[sectionName]?.esw_id?.type === 'validate' && <ErrorDiv>Please select an ESW</ErrorDiv>}

                </BootstrapCol>
            </BootstrapRow>

        </FieldsetContainer>
    )
}


export default HookSubFormESW;
